<!--会员一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">注册会员</span>
      </div>
      <div class="right">
        <Button type="primary" @click="showAddModal" v-if="user.code === 'xiaoxian'"
          >新增</Button
        >
      </div>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <Input style="width: 300px" v-model="page.value" placeholder="根据条件搜索">
          <Select v-model="page.cond" slot="prepend" style="width: 120px">
            <!-- <Option value="name">名称</Option> -->
            <!-- <Option value="tel">电话</Option> -->
            <Option value="a.tel">手机/员工号</Option>
            <Option value="a.name">姓名</Option>
            <Option value="a.account">ID账号</Option>
            <!-- <Option value="a.area">地区</Option> -->
            <Option value="c.name">学校名称</Option>
          </Select>
        </Input>
        <span class="subtitle" style="margin-left: 10px">类型</span>
        <Select v-model="page.type" style="width: 120px; margin-left: 5px">
          <Option value="-1">全部</Option>
          <Option value="0">会员</Option>
          <Option value="1">学校员工</Option>
        </Select>
       <!--  <span class="subtitle" style="margin-left: 10px">注册时间</span>
        <DatePicker
          type="date"
          v-model="page.start"
          placeholder="开始时间"
          style="width: 120px"
        >
        </DatePicker>
        <span style="margin-left: 5px">至</span>
        <DatePicker
          type="date"
          v-model="page.end"
          placeholder="结束时间"
          style="width: 130px; margin-left: 5px"
        ></DatePicker> -->

        <span class="subtitle" style="margin-left: 10px">状态</span>
        <Select v-model="page.is_del" style="width: 100px; margin-left: 5px">
          <Option :value="0" style="text-align: center">正常</Option>
          <Option :value="1" style="text-align: center">禁用</Option>
        </Select>
      </div>
      <div class="bottom">
        <Poptip trigger="hover" title="筛选" content="content" placement="left">
          <Button icon="md-list-box" style="margin: 0 5px 1px 0"></Button>
          <div slot="content" class="group">
            <Button
              size="small"
              style="margin: 0 5px 5px 0"
              v-for="(item, index) in col"
              :key="index"
              :type="item.show ? 'primary' : 'default'"
              @click="item.show = !item.show"
            >
              <span>{{ item.title }}</span>
            </Button>
          </div>
        </Poptip>
        <span class="btn-filter" @click="tableLoading ? null : getData(1)">筛选</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <!-- <Button type="success" @click="exportData(1)">导出所有页</Button> -->
          </div>
        </Poptip>
      </div>
    </div>

    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-sort-change="tableSort"
      />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        :current="page.p + 1"
        show-elevator
        :page-size-opts="pageSizeOpts"
        show-sizer
        show-total
      />
    </div>
    <Modal v-model="modal" :width="800" :title="`用户信息 - ${current.name}`">
      <Tabs :animated="false" v-model="tabs" size="small" @on-click="tabsChange">
        <!-- <TabPane label="充值">
          <Row>
            <Col :span="3" style="line-height: 32px">充值金额:</Col>
            <Col :span="5"><InputNumber :active-change="false" :precision="2" :min="0.01" v-model="recharge.money" placeholder="充值金额"/></Col>
            <Col :span="3" style="line-height: 32px">充值备注:</Col>
            <Col :span="9"><Input v-model="recharge.note" placeholder="充值备注"/></Col>
            <Col :span="4" style="text-align:right"><Button type="primary" @click="doRecharge" :loading="recharge_loading">充值</Button></Col>
          </Row>
                            </TabPane> -->
        <TabPane label="清零">
          <Row>
            <Col :span="3">钱包余额:</Col>
            <Col :span="5">{{ userMoney.money }}</Col>
            <Col :span="4" style="text-align: right"
              ><Button type="primary" @click="clearUserMoney" :loading="recharge_loading"
                >立即清零</Button
              ></Col
            >
          </Row>
        </TabPane>
        <TabPane label="充值记录">
          <Table
            size="small"
            :height="300"
            :columns="recharge_col"
            :data="recharge.logs"
            :loading="rechargeTableLoading"
          />
        </TabPane>
        <TabPane label="消费记录">
          <Table
            size="small"
            :height="300"
            :columns="consumption_columns"
            :data="consumption_data"
            :loading="consumption_loading"
          />
        </TabPane>

        <TabPane label="赠券" v-if="user.tp === 0">
          <Form :label-width="80">
            <FormItem label="优惠券">
              <Select v-model="sendCoupon.coupon_id" placement="bottom" :transfer="true">
                <Option v-for="item in couponData" :value="item.id" :key="item.id">{{
                  item.name
                }}</Option>
              </Select>
            </FormItem>
            <FormItem label="数量">
              <InputNumber :max="10" :min="1" v-model="sendCoupon.number"></InputNumber>
            </FormItem>
            <FormItem label="">
              <Button type="primary" :loading="sendCoupon.loading" @click="sendUserCoupon"
                >立即赠送</Button
              >
            </FormItem>
          </Form>
        </TabPane>
      </Tabs>
      <div slot="footer">
        <Button @click="modal = false">关闭</Button>
      </div>
    </Modal>

    <Modal
      v-model="addModal.visible"
      width="750"
      title="新增教师账号"
      :loading="addModal.loading"
    >
      <Form
        ref="formInline"
        :model="addModal.form"
        :rules="addModal.rule"
        :label-width="100"
      >
        <FormItem prop="tel" label="账号:">
          <Input
            v-model="addModal.form.tel"
            class="item_form"
            style="width: 300px"
            placeholder="输入教师手机号"
          />
        </FormItem>
      </Form>
      <div class="schoolList" v-if="addModal.schoolList.length">
        <div class="title">请勾选学校点确定后绑卡</div>
        <div class="schoolList_box" v-for="(item, index) in addModal.schoolList">
          <div class="itemRadio">
            <!-- :disabled="item.isReg" -->

            <Radio
              v-model="item.select"
              :true-value="1"
              :false-value="0"
              size="large"
              @on-change="selectSchool($event, index)"
              ><span class="schoolTitle"
                >所属学校{{ index + 1 }}{{ item.isReg ? "（已存在）" : "" }}</span
              ></Radio
            >
          </div>
          <div class="itemInfo">
            <div class="it">学校ID&nbsp;:&nbsp;{{ item.old_code }}</div>
            <div class="it">姓名&nbsp;:&nbsp;{{ item.name }}</div>
          </div>
          <div class="itemInfo">
            <div class="it">教师ID&nbsp;:&nbsp;{{ item.userId }}</div>
            <div class="it">所属学校&nbsp;:&nbsp;{{ item.company_name }}</div>
          </div>
        </div>
      </div>
      <!-- {{ addModal.schoolList }} -->
      <div slot="footer" style="text-align: right">
        <Button @click="cancel">取消</Button>
        <Button
          type="primary"
          :loading="addModal.loading"
          @click="modalOk"
          style="margin-left: 10px"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="bindCardModal.visible"
      width="600"
      title="绑卡"
      :loading="bindCardModal.loading"
    >
      <Alert type="info" show-icon style="color: #d60000; font-weight: 500"
        >请仔细核对教师信息，确保绑卡信息无误</Alert
      >
      <div class="info-box">
        <div class="title">教师信息</div>
        <div class="item">
          <p class="title">手机号：</p>
          <p class="val">{{ bindCardModal.data.tel }}</p>
        </div>
        <div class="item">
          <p class="title">姓名：</p>
          <p class="val">{{ bindCardModal.data.name }}</p>
        </div>
        <div class="item">
          <p class="title">教师ID：</p>
          <p class="val">{{ bindCardModal.data.account }}</p>
        </div>
        <div class="item">
          <p class="title">所属学校：</p>
          <p class="val">{{ bindCardModal.data.company_name }}</p>
        </div>
      </div>
      <div class="info-box">
        <div class="title" style="margin-bottom: 10px">绑定卡号</div>
        <Form
          ref="formBind"
          :model="bindCardModal.data"
          :rules="bindCardModal.rule"
          :label-width="0"
        >
          <FormItem prop="card_no">
            <Input
              v-model="bindCardModal.data.card_no"
              class="item_form"
              style="width: 300px"
              placeholder="请刷卡或者正确输入卡号"
              :autofocus="true"
              clearable
            />
          </FormItem>
        </Form>
      </div>

      <div slot="footer" style="text-align: right">
        <Button @click="cancelBindModal">取消</Button>
        <Button
          type="primary"
          :loading="bindCardModal.loading"
          @click="cardModalOk"
          style="margin-left: 10px"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="bindCardModal.visible"
      width="600"
      title="绑卡"
      :loading="bindCardModal.loading"
    >
      <Alert type="info" show-icon style="color: #d60000; font-weight: 500"
        >请仔细核对教师信息，确保绑卡信息无误</Alert
      >
      <div class="info-box">
        <div class="title">教师信息</div>
        <div class="item">
          <p class="title">手机号：</p>
          <p class="val">{{ bindCardModal.data.tel }}</p>
        </div>
        <div class="item">
          <p class="title">姓名：</p>
          <p class="val">{{ bindCardModal.data.name }}</p>
        </div>
        <div class="item">
          <p class="title">教师ID：</p>
          <p class="val">{{ bindCardModal.data.account }}</p>
        </div>
        <div class="item">
          <p class="title">所属学校：</p>
          <p class="val">{{ bindCardModal.data.company_name }}</p>
        </div>
      </div>
      <div class="info-box">
        <div class="title" style="margin-bottom: 10px">绑定卡号</div>
        <Form
          ref="formBind"
          :model="bindCardModal.data"
          :rules="bindCardModal.rule"
          :label-width="0"
        >
          <FormItem prop="card_no">
            <Input
              v-model="bindCardModal.data.card_no"
              class="item_form"
              style="width: 300px"
              placeholder="请刷卡或者正确输入卡号"
              :autofocus="true"
              clearable
            />
          </FormItem>
        </Form>
      </div>

      <div slot="footer" style="text-align: right">
        <Button @click="cancelBindModal">取消</Button>
        <Button
          type="primary"
          :loading="bindCardModal.loading"
          @click="cardModalOk"
          style="margin-left: 10px"
          >确定</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="cardListModal.visible"
      width="600"
      title="编辑教师信息"
      :loading="cardListModal.loading"
    >
      <div class="info-box">
        <div class="title">教师信息</div>
        <div class="item">
          <p class="title">手机号：</p>
          <p class="val">{{ cardListModal.data.tel }}</p>
        </div>
        <div class="item">
          <p class="title">姓名：</p>
          <p class="val">{{ cardListModal.data.name }}</p>
        </div>
        <div class="item">
          <p class="title">教师ID：</p>
          <p class="val">{{ cardListModal.data.account }}</p>
        </div>
        <div class="item">
          <p class="title">所属学校：</p>
          <p class="val">{{ cardListModal.data.company_name }}</p>
        </div>
      </div>
      <div class="info-box">
        <div class="title" style="margin-bottom: 10px">已绑卡号</div>
        <div class="cardList">
          <div class="card-item" v-for="(item, index) in cardListModal.list">
            <p class="no">{{ item.card_no }}</p>
            <p class="btn" @click="unbindCard(item.id)">解绑</p>
          </div>
          <div class="card-item">
            <p class="add" @click="addBtnClick">绑新卡</p>
          </div>
        </div>
      </div>

      <div slot="footer" style="text-align: right">
        <!-- <Button @click="cardListModal.visible">取消</Button>
        <Button
          type="primary"
          :loading="cardListModal.loading"
          @click="cardModalOk"
          style="margin-left: 10px"
          >确定</Button
        > -->
      </div>
    </Modal>

    <Modal
      v-model="editModal.visible"
      width="600"
      title="编辑"
      :loading="editModal.loading"
    >
      <div class="info-box">
        <Form
          ref="formEdit"
          :model="editModal.data"
          :rules="editModal.rule"
          :label-width="100"
        >
          <FormItem prop="tel" label="手机号">
            <Input
              v-model="editModal.data.tel"
              class="item_form"
              style="width: 300px"
              placeholder="请输入教师手机号"
              :autofocus="true"
              clearable
            />
          </FormItem>
          <FormItem prop="tel" label="姓名">
            <Input
              v-model="editModal.data.name"
              class="item_form"
              style="width: 300px"
              placeholder="请输入教师姓名"
              :autofocus="true"
              clearable
            />
          </FormItem>
        </Form>
      </div>

      <div slot="footer" style="text-align: right">
        <Button @click="editModal.visible = false">取消</Button>
        <Button
          type="primary"
          :loading="editModal.loading"
          @click="editModalOk"
          style="margin-left: 10px"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";

const validatePhone = (rule, value, callback) => {
  // if (!value) {
  //   return callback(new Error("请输入手机号"));
  // } else if (!/^1[3456789]\d{9}$/.test(value)) {
  //   callback("请输入正确的手机号");
  // } else {
  //   callback();
  // }

  if (!value) {
    return callback(new Error("请输入手机号"));
  } else if (value.length !== 11) {
    callback("请输入正确的手机号");
  } else {
    callback();
  }
};
export default {
  data() {
    return {
      consumption_loading: false,
      consumption_columns: [
        { key: "id", width: 100, title: "编号" },
        { key: "money", width: 60, title: "金额" },
        {
          key: "create_time",
          width: 135,
          title: "消费时间",
          render: (h, data) => {
            return h("span", this.$moment(data.row.create_time));
          },
        },
        { key: "order_no", title: "订单号" },
        { key: "log", title: "日志" },
        { key: "job_ids", title: "任务编号" },
      ],
      consumption_data: [],
      page: {
        p: 0,
        l: 10,
        cond: "a.tel",
        value: "",
        is_del: 0,
        key: "id",
        order: "desc",
        start: "",
        end: "",
        type: "-1",
      },
      pageSizeOpts: [10, 50, 100, 150],
      data: [],
      total: 0,
      tableLoading: false,
      modal: false,
      tabs: 0,
      recharge: {
        user_id: 0,
        money: 1,
        note: "",
        logs: [], // 充值记录数据
      }, // 充值
      recharge_loading: false,
      current: {}, // 模态框当前会员
      col: [
        {
          key: "create_time",
          title: "注册时间",
          show: true,
          fixed: "left",
          width: 135,
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        { title: "ID账号", fixed: "left", width: 150, key: "account", show: true },
        { title: "手机/员工号", fixed: "left", width: 110, key: "tel", show: true },
        {
          title: "类型",
          key: "is_staff",
          sortable: "custom",
          fixed: "left",
          width: 90,
          show: true,
          render: (h, data) => {
            return h("span", {}, data.row.is_staff ? "学校员工" : "会员");
          },
        },
        { title: "姓名", key: "name", width: 180, show: true },
        {
          title: "性别",
          key: "gender",
          width: 80,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              data.row.gender ? (data.row.gender === 1 ? "男" : "未知") : "女"
            );
          },
        },
        // { title: "电话", key: "phone", width: 110, show: true },
        {
          title: "卡号",
          key: "idcard",
          width: 180,
          show: true,
          render: (h, data) => {
            const spans = [
              h("span", { style: { paddingRight: "10px" } }, data.row.idcard),
            ];
            if (this.user.code === "xiaoxian") {
              spans.push(
                h(
                  "span",
                  {
                    style: { color: "#2d8cf0", cursor: "pointer" },
                    on: {
                      click: () => {
                        this.showCardList(data.row.id);
                      },
                    },
                  },
                  "更多"
                )
              );
            }

            return spans;
          },
        },
        // { title: "邮箱", key: "email", width: 110, show: true, tooltip: true },
        // { title: "地区", key: "area", width: 110, show: true, tooltip: true },
        {
          title: "学校",
          key: "company_name",
          width: 110,
          show: true,
          tooltip: true,
        },
        {
          title: "状态",
          key: "is_del",
          width: 90,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              { style: { color: data.row.is_del ? "#ed4014" : "#19be6b" } },
              data.row.is_del ? "禁用" : "正常"
            );
          },
        },
        {
          title: "最后登录时间",
          key: "login_time",
          width: 135,
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.login_time ? this.$moment(data.row.login_time) : "-"
            );
          },
        },
        {
          title: "最后作业时间",
          width: 135,
          key: "work_time",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              {},
              data.row.work_time ? this.$moment(data.row.work_time) : "-"
            );
          },
        },
      ],
      end: [
        {
          title: "操作",
          key: "operator",
          fixed: "right",
          width: 122,
          render: (h, data) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: `${data.row.is_del ? "success" : "error"}`,
                    size: "small",
                  },
                  style: { marginRight: "5px" },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `${data.row.is_del ? "启用" : "禁用"}`,
                        content: `是否${data.row.is_del ? "启用" : "禁用"}此会员`,
                        onOk: () => {
                          let temp = JSON.parse(JSON.stringify(data.row));
                          delete temp._index;
                          delete temp._rowKey;
                          delete temp.create_time;
                          temp.is_del = temp.is_del ? 0 : 1;
                          this.saveUser({ id: temp.id, is_del: temp.is_del });
                        },
                      });
                    },
                  },
                },
                `${data.row.is_del ? (data.row.is_del < 0 ? "通过" : "启用") : "禁用"}`
              ),
              h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  on: {
                    click: () => {
                      // 打开模态框
                      this.editModal.visible = true;
                      this.editModal.data = {
                        id: data.row.id,
                        name: data.row.name,
                        tel: data.row.tel,
                      };
                    },
                  },
                },
                "编辑"
              ),

              /* h(
                "Button",
                {
                  props: { type: "warning", size: "small" },
                  on: {
                    click: () => {
                      // 打开模态框 用选项卡列出 充值 充值记录 消费记录
                      if (data.row.is_staff) {
                        this.$Message.warning("学校员工不可编辑");
                        return false;
                      }
                      this.modal = true;
                      this.current = data.row;
                      this.tabs = 0;
                      this.recharge = {
                        user_id: data.row.id,
                        money: 1,
                        note: "",
                      };
                      this.userMoney = {
                        user_id: data.row.id,
                        money: data.row.money,
                      };
                      this.sendCoupon.user_id = data.row.id;
                    },
                  },
                },
                "编辑"
              ), */
            ]);
          },
        },
      ],
      userMoney: {
        user_id: 0,
        money: 0,
      },
      columns: [],
      recharge_col: [
        { title: "编号", width: 100, key: "id" },
        {
          title: "充值时间",
          width: 135,
          key: "create_time",
          render: (h, data) => {
            return h("span", {}, this.$moment(data.row.create_time));
          },
        },
        { title: "金额", key: "money" },
        { title: "支付单号", key: "order_no", tooltip: true, width: 200 },
        { title: "备注", key: "note", tooltip: true },
        {
          title: "充值方式",
          key: "type",
          render: (h, data) => {
            switch (data.row.type) {
              case 0:
                return h("span", {}, "人工");
              case 1:
                return h("span", {}, "支付宝");
              case 2:
                return h("span", {}, "微信");
            }
          },
        },
      ], // 充值记录列
      rechargeTableLoading: false, // 充值记录表格加载
      couponData: [],
      sendCoupon: {
        coupon_id: 0,
        number: 1,
        loading: false,
        user_id: 0,
      },
      addModal: {
        visible: false,
        loading: false,
        form: {
          tel: "",
          name: "",
          account: "",
          company_id: 0,
          agent_id: 0,
        },
        schoolList: [],
        rule: {
          tel: [
            { required: true, message: "请输入教师手机号", trigger: "blur" },
            { required: true, validator: validatePhone, trigger: "blur" },
          ],
        },
      },
      bindCardModal: {
        visible: false,
        loading: false,
        source: 0,
        data: {
          user_id: 0,
          card_no: "",
          tel: "",
          name: "",
          account: "",
          company_id: 0,
          company_name: "",
          agent_id: 0,
          staff_id: 0,
        },
        rule: {
          card_no: [{ required: true, message: "请输入卡号", trigger: "blur" }],
        },
      },
      cardListModal: {
        visible: false,
        data: {
          user_id: 0,
          card_no: "",
          tel: "",
          name: "",
          account: "",
          company_id: 0,
          company_name: "",
          agent_id: 0,
          staff_id: 0,
        },
        list: [],
      },
      editModal: {
        visible: false,
        loading: false,
        data: {
          id: 0,
          tel: "",
          name: "",
        },
        rule: {
          tel: [{ required: true, message: "请输入教师手机号", trigger: "blur" }],
          name: [{ required: true, message: "请输入教师姓名", trigger: "blur" }],
        },
      },
    };
  },
  methods: {
    tableSort(col) {
      this.page.key = col.key;
      this.page.order = col.order;
      this.getData();
    },
    tabsChange(tab) {
      switch (tab) {
        case 1: // 查询充值记录
          this.rechargeTableLoading = true;
          this.userRecharge({ p: 0, l: 10000, id: this.current.id }).then((res) => {
            this.recharge.logs = res;
            this.rechargeTableLoading = false;
          });
          break;
        case 2: // 查询消费记录
          this.consumption_loading = true;
          this.UserConsumptionRecord({ id: this.current.id }).then((res) => {
            this.consumption_data = res;
            this.consumption_loading = false;
          });
          break;
      }
    },
    // 执行充值
    doRecharge() {
      this.recharge_loading = true;
      this.rechargeDo(this.recharge).then((res) => {
        if (res) {
          this.getData();
          this.recharge_loading = false;
          this.$Message.success("充值成功!");
        }
      });
    },
    // 格式化表格
    formatCol() {
      let temp = [];
      this.col.map((item) => {
        if (item.show) {
          temp.push(item);
        }
      });
      this.columns = temp.concat(this.end);
    },
    // 重置查询
    reset() {
      this.page = {
        p: 0,
        l: 10,
        cond: "a.tel",
        value: "",
        is_del: 0,
        key: "id",
        order: "desc",
        start: "",
        end: "",
        type: "-1",
      };
      this.getData(1);
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    getData(filter) {
      if (filter) {
        this.page.p = 0;
      }
      this.tableLoading = true;
      let cond = JSON.parse(JSON.stringify(this.page));
      if (this.page.type != "-1") {
        cond.is_staff = this.page.type;
      }
      if (this.page.start && this.page.end) {
        cond.start = this.$moment(this.page.start, "YYYY-MM-DD");
        cond.end = this.$moment(this.page.end, "YYYY-MM-DD");
      }
      this.getUsers(cond).then((res) => {
        /* if (this.user.tp) {
          res.data.map((item) => {
            if (item.tel) {
              item.tel =
                item.tel.substr(0, 3) + "****" + item.tel.substr(7, item.tel.length);
            }
          });
        } */
        this.data = res.data;
        this.total = res.total;
        this.tableLoading = false;
      });
    },
    // 格式化数据
    excelData(data) {
      data = JSON.parse(JSON.stringify(data));
      data.map((item) => {
        item.gender = item.gender ? "男" : "女";
        item.is_del = item.is_del ? "禁用" : "正常";
        item.create_time = this.$moment(item.create_time);
        item.open_id = item.open_id ? "已绑定" : "未绑定";
        item.free_space = `${item.free_space / 1024}M/${item.disk_space / 1024}M`;
        item.is_staff = item.is_staff ? "员工" : "会员";
        item.login_time = item.login_time ? this.$moment(item.login_time) : "";
        item.work_time = item.work_time ? this.$moment(item.work_time) : "";
      });
      return data;
    },
    // 导出数据
    exportData(is_all) {
      let title = [],
        key = [];
      this.col.map((item) => {
        if (item.show) {
          title.push(item.title);
          key.push(item.key);
        }
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "注册会员列表",
      };
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page));
        page.l = this.total;
        page.p = 0;
        this.getUsers(page).then((res) => {
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        this.data.map((item) => {
          item.app_openid = item.app_openid ? "已绑定" : "未绑定";
          item.dd_openid = item.dd_openid ? "已绑定" : "未绑定";
        });
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    saveUser(data) {
      this.putUser(data).then((res) => {
        this.data.map((item) => {
          if (item.id === data.id) {
            item.is_del = data.is_del;
          }
        });
      });
    },
    clearUserMoney() {
      this.recharge_loading = true;
      this.ClearUserMoney({ user_id: this.userMoney.user_id })
        .then((res) => {
          this.recharge_loading = false;
          if (res.status) {
            this.getData();
            this.$Message.success("操作成功!");
            this.userMoney.money = 0;
          } else {
            this.$Message.error(res.msg);
          }
        })
        .catch((e) => {
          this.recharge_loading = false;
          this.$Message.error("系统错误");
        });
    },
    getCoupon() {
      this.getCouponAll().then((res) => {
        this.couponData = res.data;
      });
    },
    sendUserCoupon() {
      const data = {
        coupon_id: this.sendCoupon.coupon_id,
        number: this.sendCoupon.number,
        user_id: this.sendCoupon.user_id,
      };
      if (!data.user_id) {
        this.$Message.error("参数错误");
        return false;
      }
      if (!data.coupon_id) {
        this.$Message.error("请选择要赠送的优惠券");
        return false;
      }
      if (!data.number || data.number > 10 || data.number < 1) {
        this.$Message.error("请填写正确的数量");
        return false;
      }
      this.sendCoupon.loading = true;
      this.SendUserCoupon(data).then((res) => {
        this.sendCoupon.loading = false;
        this.$Message[res.status ? "success" : "error"](res.msg);
        if (res.status) {
          this.sendCoupon.coupon_id = 0;
          this.sendCoupon.number = 1;
        }
      });
    },
    cancel() {
      this.addModal.visible = false;
    },
    showAddModal() {
      this.addModal.visible = true;
      this.$refs.formInline.resetFields();
      this.addModal.form = {
        name: "",
        account: "",
        tel: "",
        company_id: 0,
        agent_id: 0,
      };
      this.addModal.schoolList = [];
    },
    modalOk() {
      if (!this.addModal.schoolList.length) {
        this.$refs.formInline.validate((valid) => {
          if (valid) {
            this.addModal.loading = true;
            this.GetXiaoXianTeacherInfo({ mobile: this.addModal.form.tel }).then(
              (res) => {
                this.addModal.loading = false;

                if (!res.status) {
                  this.$Message.error(res.msg);
                  return;
                }
                res.data.map((item) => {
                  item.select = 0;
                });
                this.addModal.schoolList = res.data;
              }
            );
          }
        });
        return false;
      }
      //创建员工

      console.log(this.addModal.form);
      this.addModal.loading = true;

      if (!this.addModal.form.account) {
        this.$Message.error("请选择学校");
        this.addModal.loading = false;
        return;
      }
      this.CreateUserStaff({ ...this.addModal.form }).then((res) => {
        this.addModal.loading = false;
        if (!res.status) {
          this.$Message.error(res.msg);
          return;
        }
        this.$Message.success("操作成功");
        // this.addModal.visible = false;
        this.showBindModal(res.data.user_id, 1);
      });
    },
    selectSchool(e, i) {
      let schoolList = this.addModal.schoolList;
      schoolList.map((item, index) => {
        if (index !== i) {
          item.select = 0;
        } else {
          this.addModal.form.name = item.name;
          this.addModal.form.account = item.userId;
          this.addModal.form.company_id = item.company_id;
          this.addModal.form.agent_id = item.agent_id;
        }
      });
    },
    showBindModal(id = 0, source = 1) {
      if (!id) {
        this.$Message.error("参数错误");
        return;
      }
      this.bindCardModal.source = source;
      //source 1:添加员工 2：修改员工
      this.bindCardModal.data.user_id = id;
      // if (source === 1) {
      //   this.addModal.visible = true;
      //   this.addModal.loading = true;
      // }
      this.GetUserStaffInfo({ user_id: this.bindCardModal.data.user_id }).then((res) => {
        if (source === 1) {
          this.addModal.visible = false;
          this.addModal.loading = false;
        }
        if (!res.status) {
          this.$Message.error(res.msg);
          return;
        }
        const { user, staff } = res.data;
        this.bindCardModal.data = {
          user_id: this.bindCardModal.data.user_id,
          company_id: staff.company_id,
          company_name: staff.company_name,
          agent_id: staff.agent_id,
          name: user.name,
          tel: user.tel,
          account: user.account,
          staff_id: staff.id,
        };
        this.bindCardModal.visible = true;
      });
    },
    cardModalOk() {
      this.bindCardModal.loading = true;
      this.$refs.formBind.validate((valid) => {
        if (!valid) {
          this.bindCardModal.loading = false;
          return;
        }
        this.BindStaffCard({
          user_id: this.bindCardModal.data.user_id,
          card_no: this.bindCardModal.data.card_no,
          staff_id: this.bindCardModal.data.staff_id,
        }).then(async (res) => {
          this.$Message[res.status ? "success" : "error"](res.msg);
          this.bindCardModal.loading = false;
          if (!res.status) return;
          this.bindCardModal.visible = false;
          if (this.bindCardModal.source === 2) {
            //获取用户卡列表
            const cards = await this.GetStaffCards({
              staff_id: this.bindCardModal.data.staff_id,
            }).then((res) => {
              return res.data;
            });
            this.cardListModal.list = cards;
            this.cardListModal.visible = true;
          }
          this.getData();
        });
      });
    },
    cancelBindModal() {
      this.bindCardModal.visible = false;
    },
    async showCardList(user_id) {
      const res = await this.GetUserStaffInfo({ user_id });
      if (!res.status) {
        this.$Message.error(res.msg);
        return;
      }
      const { user, staff } = res.data;
      this.cardListModal.data = {
        user_id,
        company_id: staff.company_id,
        company_name: staff.company_name,
        agent_id: staff.agent_id,
        name: user.name,
        tel: user.tel,
        account: user.account,
        staff_id: staff.id,
      };
      const cards = await this.GetStaffCards({ staff_id: staff.id }).then((res) => {
        return res.data;
      });
      this.cardListModal.list = cards;
      this.cardListModal.visible = true;
    },
    unbindCard(id) {
      this.$Modal.confirm({
        title: "重要提醒",
        content: "解绑后该卡将无法使用，是否确认解绑？",
        onOk: async () => {
          const res = await this.UnbindCard({ id });
          this.$Message[res.status ? "success" : "error"](res.msg);
          if (!res.status) return;
          const cards = await this.GetStaffCards({
            staff_id: this.cardListModal.data.staff_id,
          }).then((res) => {
            return res.data;
          });
          this.cardListModal.list = cards;
        },
      });
    },
    addBtnClick() {
      console.log(this.cardListModal.data.user_id);
      this.showBindModal(this.cardListModal.data.user_id, 2);
    },

    editModalOk() {
      console.log('editModalOk')
      this.editModal.loading = true;
      this.$refs.formEdit.validate((valid) => {
        if (!valid) {
          this.editModal.loading = false;
          return;
        }
        const data = { ...this.editModal.data };
        this.putUser(data).then((res) => {
          this.editModal.loading = false;
          if (res) {
            this.editModal.visible = false;
            this.$Message.success('编辑成功');
            this.getData();
          } else {
            this.$Message.error('编辑失败');
          }
        });
      });
    },

    ...mapActions([
      "getUsers",
      "putUser",
      "rechargeDo",
      "userRecharge",
      "UserConsumptionRecord",
      "ClearUserMoney",
      "getCouponAll",
      "SendUserCoupon",
      "GetXiaoXianTeacherInfo",
      "CreateUserStaff",
      "GetUserStaffInfo",
      "BindStaffCard",
      "GetStaffCards",
      "UnbindCard",
    ]),
  },
  mounted() {
    this.getData();
    this.formatCol();
    if (this.user.tp === 0) this.getCoupon();
    // this.showCardList(992169);
  },
  computed: mapGetters({
    user: "agent",
  }),
  watch: {
    col: {
      handler(n, o) {
        this.formatCol();
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
